import React, { useCallback } from "react";
import { File } from "src/shared/models";
import { getUSFormattedDate, getUSFormatedTime } from "src/shared/utils";
import "./index.scss";
import { AccessControl, Icon } from "src/shared/components";

export interface FileItemProps {
  file: File;
  onDelete?: (file: File) => void;
  permission?: string;
  companyCode?: string | null;
  isDisabled?: boolean;
}

const FileItem = (props: FileItemProps) => {
  const { file, onDelete, permission, companyCode, isDisabled = false } = props;

  const handleDelete = useCallback(() => {
    onDelete?.(file);
  }, [onDelete, file]);

  return (
    <div className="file-item">
      <div className="file-item-header">
        <div className="left-file-item-header">
          <a target="_blank" href={file.url} rel="noreferrer">
            {file.name}
          </a>
        </div>
        <div className="right-file-item-header">
          {file.creator && (
            <>
              <div className="file-user">{`${file.creator.first_name} ${file.creator.last_name}`}</div>
              <div className="file-devider">|</div>
            </>
          )}
          <div className="file-date">
            {`${getUSFormattedDate(file.created_at)} ${getUSFormatedTime(file.created_at)}`}
          </div>
        </div>
        <AccessControl permission={permission || ""} option={{ companyCode, onlyAppAdmin: !companyCode }}>
          {!isDisabled ? <Icon type="close" onClick={handleDelete} /> : null}
        </AccessControl>
      </div>
    </div>
  );
};

export default FileItem;
